/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateSupplierOfferRequest,
  GetSupplierOfferParams,
  ListSupplierOffersParams,
  PaginatedSupplierOfferDto,
  SupplierOfferDto,
  SupplierOfferId,
  UpdateSupplierOfferRequest,
} from "../model";

import {customFetch} from "../../../runtime/custom-fetch";

export const getGetSupplierOfferUrl = (
  supplierId: string,
  catalogItemId: string,
  params?: GetSupplierOfferParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/supplier-offers/${supplierId}/${catalogItemId}?${stringifiedParams}`
    : `/api/v1/engineering/supplier-offers/${supplierId}/${catalogItemId}`;
};

/**
 * @summary Get supplier offer
 */
export const getSupplierOffer = async (
  supplierId: string,
  catalogItemId: string,
  params?: GetSupplierOfferParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierOfferDto> => {
  return customFetch<SupplierOfferDto>(getGetSupplierOfferUrl(supplierId, catalogItemId, params), {
    ...options,
    method: "GET",
  });
};

export const getUpdateSupplierOfferUrl = (supplierId: string, catalogItemId: string) => {
  return `/api/v1/engineering/supplier-offers/${supplierId}/${catalogItemId}`;
};

/**
 * @summary Update supplier offer
 */
export const updateSupplierOffer = async (
  supplierId: string,
  catalogItemId: string,
  updateSupplierOfferRequest: UpdateSupplierOfferRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getUpdateSupplierOfferUrl(supplierId, catalogItemId), {
    ...options,
    method: "PUT",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(updateSupplierOfferRequest),
  });
};

export const getDeleteSupplierOfferUrl = (supplierId: string, catalogItemId: string) => {
  return `/api/v1/engineering/supplier-offers/${supplierId}/${catalogItemId}`;
};

/**
 * @summary Delete supplier offer
 */
export const deleteSupplierOffer = async (
  supplierId: string,
  catalogItemId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getDeleteSupplierOfferUrl(supplierId, catalogItemId), {
    ...options,
    method: "DELETE",
  });
};

export const getListSupplierOffersUrl = (params: ListSupplierOffersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/engineering/supplier-offers?${stringifiedParams}`
    : `/api/v1/engineering/supplier-offers`;
};

/**
 * @summary List supplier offers
 */
export const listSupplierOffers = async (
  params: ListSupplierOffersParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<PaginatedSupplierOfferDto> => {
  return customFetch<PaginatedSupplierOfferDto>(getListSupplierOffersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getCreateSupplierOfferUrl = () => {
  return `/api/v1/engineering/supplier-offers`;
};

/**
 * @summary Create supplier offer
 */
export const createSupplierOffer = async (
  createSupplierOfferRequest: CreateSupplierOfferRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<SupplierOfferId> => {
  return customFetch<SupplierOfferId>(getCreateSupplierOfferUrl(), {
    ...options,
    method: "POST",
    headers: {"Content-Type": "application/json", ...options?.headers},
    body: JSON.stringify(createSupplierOfferRequest),
  });
};

export const getRestoreSupplierOfferUrl = (supplierId: string, catalogItemId: string) => {
  return `/api/v1/engineering/supplier-offers/${supplierId}/${catalogItemId}/restore`;
};

/**
 * @summary Restore supplier offer
 */
export const restoreSupplierOffer = async (
  supplierId: string,
  catalogItemId: string,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getRestoreSupplierOfferUrl(supplierId, catalogItemId), {
    ...options,
    method: "POST",
  });
};
